(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-application-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSlider(wrap) {
    var grid  = wrap.querySelector('[data-jk-app-grid]');
    var dots  = Array.from(wrap.querySelectorAll('[data-jk-app-dot]'));
    var cards = grid ? Array.from(grid.querySelectorAll('.jk-application__step')) : [];
    if (!grid || !cards.length) return;

    function setActive(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    // Derive active index from scroll position
    function getActiveIndex() {
      var cardW = cards[0] ? cards[0].offsetWidth : 1;
      var gap   = parseFloat(window.getComputedStyle(grid).columnGap) || 16;
      return Math.min(
        Math.round(grid.scrollLeft / (cardW + gap)),
        cards.length - 1
      );
    }

    // Update dots on scroll using rAF for performance
    var ticking = false;
    grid.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(getActiveIndex());
        ticking = false;
      });
    }, { passive: true });

    // Dot tap: scroll to the corresponding card
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx  = parseInt(dot.getAttribute('data-jk-app-dot'), 10);
        var card = cards[idx];
        if (!card) return;
        // offsetLeft is relative to the grid; accounts for padding-left automatically
        grid.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-jk-app-slider]').forEach(initSlider);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor re-renders
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-article-main"] && !Shopify.designMode) return;
  try {
    
/* Inhaltsverzeichnis (Editorial v01, 28.08.2026): progressiv aus den
   H2 des Artikel-Bodys gebaut — unter 3 H2 bleibt der Container
   hidden. Slugs dedupliziert; kein Scroll-Listener, native Anker. */
(function () {
  var toc = document.querySelector('[data-jk-toc]');
  var list = document.querySelector('[data-jk-toc-list]');
  var body = document.querySelector('.jk-article-main__content');
  if (!toc || !list || !body) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length < 3) return;

  var seen = {};
  headings.forEach(function (h) {
    var slug = h.textContent.trim().toLowerCase()
      .replace(/[^a-z0-9äöüß\s-]/g, '')
      .replace(/[äöüß]/g, function (c) { return ({ 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss' })[c]; })
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    if (seen[slug]) {
      seen[slug] += 1;
      slug = slug + '-' + seen[slug];
    } else {
      seen[slug] = 1;
    }
    if (!h.id) h.id = slug;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });

  toc.removeAttribute('hidden');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-hero-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mobile = window.matchMedia('(max-width: 749px)').matches;

  document.querySelectorAll('.jk-hero__video').forEach(function (v) {
    // Desktop video + mobile image only: leave video sourceless on mobile
    // so the poster (mobile image) shows without downloading any video.
    if (mobile && v.dataset.mobilePosterOnly) return;

    var srcs  = ((mobile && v.dataset.mSrcs  ? v.dataset.mSrcs  : null) || v.dataset.dSrcs  || '').split('||');
    var types = ((mobile && v.dataset.mTypes ? v.dataset.mTypes : null) || v.dataset.dTypes || '').split('||');

    var hasSource = false;
    srcs.forEach(function (src, i) {
      if (!src) return;
      var s = document.createElement('source');
      s.src = src;
      if (types[i]) s.type = types[i];
      v.appendChild(s);
      hasSource = true;
    });
    if (hasSource) v.load();

    // Show fallback image if video errors
    v.addEventListener('error', function () {
      var fallback = v.parentElement && v.parentElement.querySelector('.jk-hero__media-el--fallback');
      if (fallback) {
        v.style.display = 'none';
        fallback.classList.add('is-visible');
      }
    });
  });

  // Pause all hero videos for prefers-reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.jk-hero__video').forEach(function (v) {
      v.pause();
      v.removeAttribute('autoplay');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-main-product"]) return;
  try {
    
if (!customElements.get('jk-sticky-atc')) {
  customElements.define(
    'jk-sticky-atc',
    class JkStickyAtc extends HTMLElement {
      connectedCallback() {
        this.quantity = 1;
        this.variantId = Number(this.dataset.variantId);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[data-sticky-submit]');
        this.labelEl = this.querySelector('[data-submit-label]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.errorEl = this.querySelector('[data-sticky-error]');
        this.qtyEl = this.querySelector('[data-qty-value]');
        try {
          this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }

        this.initVisibility();
        this.initMedia();

        this.querySelectorAll('[data-qty-step]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.quantity = Math.max(1, this.quantity + Number(btn.dataset.qtyStep));
            this.qtyEl.textContent = this.quantity;
          });
        });
        this.submitBtn.addEventListener('click', this.onSubmit.bind(this));

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data && event.data.variant;
            if (variant) this.onVariantChange(variant);
          });
        }
      }

      disconnectedCallback() {
        if (this.variantUnsub) this.variantUnsub();
        if (this.observer) this.observer.disconnect();
      }

      /* Nur unterhalb des regulaeren ATC einblenden: rect.bottom < 0 =
         Button hat den Viewport nach oben verlassen. */
      initVisibility() {
        const target =
          document.getElementById('ProductSubmitButton-' + this.dataset.sectionId) ||
          document.querySelector('.product-form__submit');
        if (!target || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.classList.toggle('jk-sticky-atc--visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
        this.observer.observe(target);
      }

      /* Bildquelle einmalig setzen, nur wenn Desktop-Breakpoint matcht
         (Skill: Desktop-/Mobile-Media nie beide laden). */
      initMedia() {
        const img = this.querySelector('.jk-sticky-atc__img');
        if (!img) return;
        const mq = window.matchMedia('(min-width: 750px)');
        const load = () => {
          if (img.src) return;
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
        };
        if (mq.matches) {
          load();
        } else {
          mq.addEventListener('change', (e) => { if (e.matches) load(); }, { once: true });
        }
      }

      onVariantChange(variant) {
        this.variantId = variant.id;
        const known = this.variants.find((v) => v.id === variant.id);
        const available = known ? known.available : variant.available;
        if (known && this.priceEl) this.priceEl.textContent = known.price;
        this.submitBtn.disabled = !available;
        this.labelEl.textContent = available ? this.submitBtn.dataset.textAtc : this.submitBtn.dataset.textSoldout;
        this.errorEl.hidden = true;
      }

      /* Einmalkauf via Cart AJAX API — bewusst OHNE selling_plan
         (Entscheid Andreas 19.08.2026). Drawer-Refresh identisch zum
         Dawn-Muster in assets/product-form.js. */
      onSubmit() {
        if (this.submitBtn.disabled || this.submitBtn.classList.contains('jk-sticky-atc__submit--loading')) return;
        this.errorEl.hidden = true;
        this.submitBtn.classList.add('jk-sticky-atc__submit--loading');
        this.submitBtn.setAttribute('aria-disabled', 'true');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', this.quantity);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'jk-sticky-atc',
                  productVariantId: this.variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.errorEl.textContent = response.description || response.message;
              this.errorEl.hidden = false;
              return;
            }
            if (!this.cart) {
              window.location = routes.cart_url;
              return;
            }
            if (typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'jk-sticky-atc',
                productVariantId: this.variantId,
                cartData: response,
              });
            }
            this.cart.renderContents(response);
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitBtn.classList.remove('jk-sticky-atc__submit--loading');
            this.submitBtn.removeAttribute('aria-disabled');
          });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-product-specs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.jk-specs').forEach(function (section) {
    var openBtn = section.querySelector('[data-jk-inci-open]');
    var dialog  = section.querySelector('[data-jk-inci-dialog]');
    if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;
    openBtn.addEventListener('click', function () { dialog.showModal(); });
    section.querySelectorAll('[data-jk-inci-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });
    // Klick auf den Backdrop (= Klick auf das dialog-Element selbst,
    // nicht auf seinen Inhalt) schliesst.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-retailer-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.querySelectorAll('.jk-retailer-list').forEach(function (root) {
    var tabs   = Array.prototype.slice.call(root.querySelectorAll('[data-jk-country-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-jk-country-panel]'));
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var country = tab.getAttribute('data-jk-country-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-jk-country-panel') !== country;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-routine-set"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function updateCartUI(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-drawer'];
      const newInner = tmp.querySelector('.drawer__inner');
      const existingInner = document.querySelector('.cart-drawer .drawer__inner');
      if (newInner && existingInner) {
        existingInner.replaceWith(newInner);
        const overlay = document.querySelector('#CartDrawer-Overlay');
        const d = document.querySelector('cart-drawer');
        if (overlay && d) overlay.addEventListener('click', d.close.bind(d));
      }
    }
    if (sections['cart-icon-bubble']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-icon-bubble'];
      const nb = tmp.querySelector('#cart-icon-bubble');
      const eb = document.getElementById('cart-icon-bubble');
      if (nb && eb) eb.replaceWith(nb);
    }
  }

  async function postToCart(items) {
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'] })
    });
    if (!resp.ok) throw new Error('cart/add.js ' + resp.status);
    return resp.json();
  }

  function initRS(root) {
    root.querySelectorAll('[data-jk-rs-add]').forEach(function (btn) {
      btn.addEventListener('click', async function (e) {
        e.stopPropagation();
        const vid = parseInt(btn.dataset.vid, 10);
        if (!vid) return;
        const saved = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<span style="font-size:var(--jk-fs-caps)">…</span>';
        try {
          const data = await postToCart([{ id: vid, quantity: 1 }]);
          updateCartUI(data.sections);
          openCartDrawer();
        } catch (err) {
          console.error('[JK RS] add failed:', err);
        } finally {
          btn.disabled = false;
          btn.innerHTML = saved;
        }
      });
    });

    const cta = root.querySelector('[data-jk-rs-cta]');
    if (cta) {
      cta.addEventListener('click', async function () {
        const vid = parseInt(cta.dataset.setVid, 10);
        if (!vid) return;
        const saved = cta.textContent;
        cta.disabled = true;
        cta.textContent = '…';
        try {
          const data = await postToCart([{ id: vid, quantity: 1 }]);
          updateCartUI(data.sections);
          openCartDrawer();
        } catch (err) {
          console.error('[JK RS] set add failed:', err);
        } finally {
          cta.disabled = false;
          cta.textContent = saved;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-jk-rs]').forEach(initRS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    const el = e.target.querySelector('[data-jk-rs]');
    if (el) initRS(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-testimonials-bento"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  document.querySelectorAll('.jk-testimonials-bento').forEach(function (sec) {
    var track = sec.querySelector('.jk-tb-grid');
    var dots  = Array.from(sec.querySelectorAll('.jk-tb-dot'));
    var cards = Array.from(sec.querySelectorAll('.jk-tb-card'));
    if (!track || !dots.length || !cards.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getActiveIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var best = 0, bestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    function setActive(idx) {
      dots.forEach(function (dot, i) {
        var on = i === idx;
        dot.classList.toggle('jk-tb-dot--active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var behavior = prefersReduced ? 'auto' : 'smooth';
        cards[i].scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'start' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          setActive(getActiveIndex());
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    setActive(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-usp-cards"] && !Shopify.designMode) return;
  try {
    
/* Drag-to-Scroll fuer Maus-Zeiger (11.08.2026): Touch/Trackpad
   scrollen nativ, die Maus bekommt Greifen-und-Ziehen wie ein
   Karussell — ohne Pfeile. Nach echtem Drag wird der naechste Klick
   unterdrueckt, damit verlinkte Kacheln nicht ausloesen. */
(function () {
  'use strict';

  document.querySelectorAll('[data-jk-usp-scroller]').forEach(function (scroller) {
    var startX = 0;
    var startLeft = 0;
    var dragged = false;
    var active = false;

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      active = true;
      dragged = false;
      startX = e.clientX;
      startLeft = scroller.scrollLeft;
    });

    /* Schwelle 5px: darunter normaler Klick, darueber Zug mit
       anschliessender Klick-Unterdrueckung (verlinkte Kacheln). */
    scroller.addEventListener('pointermove', function (e) {
      if (!active) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) > 5) {
        dragged = true;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(e.pointerId);
      }
      if (dragged) scroller.scrollLeft = startLeft - dx;
    });

    /* Natives Bild-/Link-Dragging blockiert sonst die Zug-Logik */
    scroller.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function endDrag() {
      if (!active) return;
      active = false;
      scroller.classList.remove('is-dragging');
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);

    scroller.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true);

    /* Pfeile (Desktop, 11.08.2026): scrollen um EINE Kachelbreite,
       am Rand deaktiviert statt ausgeblendet; ohne Ueberlauf bleibt
       die Leiste komplett verborgen. */
    var section = scroller.closest('.jk-usp');
    var nav = section ? section.querySelector('[data-jk-usp-nav]') : null;
    if (nav) {
      var prev = nav.querySelector('[data-jk-usp-prev]');
      var next = nav.querySelector('[data-jk-usp-next]');
      var counter = nav.querySelector('[data-jk-usp-counter]');
      var total = scroller.querySelectorAll('.jk-usp__card').length;

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function cardStep() {
        var card = scroller.querySelector('.jk-usp__card');
        if (!card) return scroller.clientWidth;
        var gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
        return card.offsetWidth + gap;
      }

      function updateNav() {
        var overflow = scroller.scrollWidth - scroller.clientWidth;
        if (overflow <= 1) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;
        prev.disabled = scroller.scrollLeft <= 1;
        next.disabled = scroller.scrollLeft >= overflow - 1;
        /* Zaehler: erste vollstaendig sichtbare Kachel (aktualisiert
           bei Scroll, Zug und Pfeilen — alles laeuft ueber scroll) */
        if (counter && total > 0) {
          var idx = Math.min(total, Math.max(1, Math.round(scroller.scrollLeft / cardStep()) + 1));
          counter.textContent = pad(idx) + ' / ' + pad(total);
        }
      }

      prev.addEventListener('click', function () {
        scroller.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });

      var navTick = false;
      scroller.addEventListener('scroll', function () {
        if (navTick) return;
        navTick = true;
        requestAnimationFrame(function () { updateNav(); navTick = false; });
      }, { passive: true });
      window.addEventListener('resize', updateNav, { passive: true });
      updateNav();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-widerruf-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jk-widerruf-form__form').forEach(function (form) {
  var itemsField = form.querySelector('[data-jk-wf-items]');
  var textarea = form.querySelector('textarea[name="contact[Artikel]"]');
  var radios = form.querySelectorAll('input[name="contact[Umfang]"]');
  if (!itemsField || !textarea || radios.length === 0) return;

  function sync() {
    var partial = form.querySelector('[data-jk-wf-scope="partial"]');
    var showItems = partial && partial.checked;
    itemsField.hidden = !showItems;
    textarea.required = !!showItems;
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', sync);
  });
  sync();
});

  } catch(e) { console.error(e); }
})();
})();
